module.exports = __webpack_public_path__ + "./docs/img/python.8a71a4e14397fffa847f7224270731c4.svg";